import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type {
	CustomerDashboardParams,
	CustomerDashboardResponse,
	CreateCustomerRequest,
	CreateCustomerResponse,
} from '../types/customer';

export const customersApi = {
	getDashboard: async (params: CustomerDashboardParams): Promise<CustomerDashboardResponse> => {
		const query = new URLSearchParams();
		query.append('locationId', String(params.locationId));
		if (params.search) query.append('search', params.search);
		if (params.sortBy) query.append('sortBy', params.sortBy);
		if (params.page !== undefined) query.append('page', String(params.page));
		if (params.size !== undefined) query.append('size', String(params.size));
		return apiClient.get<CustomerDashboardResponse>(
			`${API_ENDPOINTS.CUSTOMER.DASHBOARD}?${query.toString()}`
		);
	},

	create: async (data: CreateCustomerRequest): Promise<CreateCustomerResponse> => {
		return apiClient.post<CreateCustomerResponse>(API_ENDPOINTS.CUSTOMER.BASE, data);
	},

	exportCsv: async (locationId: number): Promise<string> => {
		return apiClient.get<string>(
			`${API_ENDPOINTS.CUSTOMER.EXPORT}?locationId=${locationId}`
		);
	},
};
